import z from "zod"
import { selectFusionApiAxios } from '../selectAxios'
import { RSecondaryCode, RUnfilteredIcd, safeParseJson , SecondaryCode, serializeFusionError, UnfilteredIcd } from '@fusion-advantage/backcompat'
import { DiagnosisReviewItem } from '@fusion-advantage/formlib'
import { AppThunk } from '../appStore'
import { onlineHttpError } from './handleApiError'
import { selectDashboardDisplayIdentity } from '../dashboardDataSlice'
import { setLdng } from '../appSlice'
import { err, ok, Result } from "neverthrow"
import { syncHttpReq, SyncHttpReqConfig} from "@fusion-advantage/formrender"
import { appError } from "../errorSlice"

const ZApiAuditAssignBody = z.object({
	Assigned: z.boolean(),
})

export const apiAuditAssign = (encounterGuid?: string): AppThunk<Promise<Result<boolean, void>>> => async (dispatch, getState) => {
	const user = selectDashboardDisplayIdentity(getState())
	if(!user) {
		dispatch(appError({
			err: serializeFusionError('apiAuditAssign', 'expected user but null')
		}))
		return err()
	}
	dispatch(setLdng({apiAudit: true}))
	const axInst = selectFusionApiAxios(getState())
	const cfg: SyncHttpReqConfig = {
		axInst,
		method: 'POST',
		url: '/api/v0/audit/assign',
		data: {
			UPN: user.upn,
			EncounterGUID: encounterGuid,
		},
	}
	const r = await syncHttpReq(cfg)
	dispatch(setLdng({apiAudit: false}))
	if(r.isErr()) {
		dispatch(appError(onlineHttpError(cfg, r.error, {})))
		return err()
	}
	const rParse = safeParseJson(r.value.data, ZApiAuditAssignBody)
	if(rParse.isErr()) {
		dispatch(appError({
			err: serializeFusionError('apiAuditAssign', rParse.error)
		}))
		return err()
	}
	return ok(rParse.value.Assigned)
}

const ZApiAuditReturnToBody = z.object({
	Returned: z.boolean(),
})

export const apiAuditReturnTo = (encounterGuid?: string): AppThunk<Promise<Result<boolean, void>>> => async (dispatch, getState) => {
	const user = selectDashboardDisplayIdentity(getState())
	if(!user) {
		dispatch(appError({
			err: serializeFusionError('apiAuditReturnTo', 'expected user but null')
		}))
		return err()
	}
	dispatch(setLdng({apiAudit: true}))
	const axInst = selectFusionApiAxios(getState())
	const cfg: SyncHttpReqConfig = {
		axInst,
		method: 'POST',
		url: '/api/v0/audit/return-to',
		data: {
			UPN: user.upn,
			EncounterGUID: encounterGuid,
		},
	}
	const r = await syncHttpReq(cfg)
	dispatch(setLdng({apiAudit: false}))
	if(r.isErr()) {
		dispatch(appError(onlineHttpError(cfg, r.error, {})))
		return err()
	}
	const rParse = safeParseJson(r.value.data, ZApiAuditReturnToBody)
	if(rParse.isErr()) {
		dispatch(appError({
			err: serializeFusionError('apiAuditReturnTo', rParse.error)
		}))
		return err()
	}
	return ok(rParse.value.Returned)
}

const ZApiAuditUnfilteredIcdBody = z.object({
	Codes: z.array(RUnfilteredIcd),
})

export const apiAuditUnfilteredIcd = (dateOfService: string): AppThunk<Promise<Result<UnfilteredIcd[], void>>> => async (dispatch, getState) => {
	const axInst = selectFusionApiAxios(getState())
	const cfg: SyncHttpReqConfig = {
		axInst,
		method: 'POST',
		url: '/api/v2/offline/table/unfiltered-icd',
		data: {
			DateOfService: dateOfService,
		},
	}
	const r = await syncHttpReq(cfg)
	if(r.isErr()) {
		dispatch(appError(onlineHttpError(cfg, r.error, {})))
		return err()
	}
	const rParse = safeParseJson(r.value.data, ZApiAuditUnfilteredIcdBody)
	if(rParse.isErr()) {
		dispatch(appError({
			err: serializeFusionError('apiAuditUnfilteredIcd', rParse.error)
		}))
		return err()
	}
	return ok(rParse.value.Codes)
}

const ZApiSecondaryCodesV3Body = z.array(RSecondaryCode)

export const apiAuditSecondaryCodesV3 = (models: DiagnosisReviewItem[], dateOfService?: string|null): AppThunk<Promise<Result<SecondaryCode[], void>>> => async (dispatch, getState) => {
	const axInst = selectFusionApiAxios(getState())
	const cfg: SyncHttpReqConfig = {
		axInst,
		method: 'POST',
		url: '/api/v3/secondary-codes',
		data: {
			Models: JSON.stringify(models),
			DateOfService: dateOfService,
		},
	}
	const r = await syncHttpReq(cfg)
	if(r.isErr()) {
		dispatch(appError(onlineHttpError(cfg, r.error, {})))
		return err()
	}
	const rParse = safeParseJson(r.value.data, ZApiSecondaryCodesV3Body)
	if(rParse.isErr()) {
		dispatch(appError({
			err: serializeFusionError('apiAuditSecondaryCodesV3', rParse.error)
		}))
		return err()
	}
	return ok(rParse.value)
}
